/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Jobs_Results_CountInputs */

const en_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} result${i?.plural}`)
};

const de_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Ergebnis${i?.plural}`)
};

const fr_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} résultat${i?.plural}`)
};

const es_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultado${i?.plural}`)
};

const it_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultato${i?.plural}`)
};

const nl_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultaat${i?.plural}`)
};

const pl_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wynik${i?.plural}`)
};

const fi_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tulos${i?.plural}`)
};

const da_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultat${i?.plural}`)
};

const sv_jobs_results_count = /** @type {(inputs: Jobs_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultat${i?.plural}`)
};

/**
* | output |
* | --- |
* | "{count} result{plural}" |
*
* @param {Jobs_Results_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_results_count = /** @type {((inputs: Jobs_Results_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Results_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_results_count(inputs)
	if (locale === "fr") return fr_jobs_results_count(inputs)
	if (locale === "es") return es_jobs_results_count(inputs)
	if (locale === "it") return it_jobs_results_count(inputs)
	if (locale === "nl") return nl_jobs_results_count(inputs)
	if (locale === "pl") return pl_jobs_results_count(inputs)
	if (locale === "fi") return fi_jobs_results_count(inputs)
	if (locale === "da") return da_jobs_results_count(inputs)
	if (locale === "sv") return sv_jobs_results_count(inputs)
	return en_jobs_results_count(inputs)
});